/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Auth0UserOrganizationsDTO } from '../models/Auth0UserOrganizationsDTO'
import type { CancelablePromise } from '../core/CancelablePromise'
import { OpenAPI } from '../core/OpenAPI'
import { request as __request } from '../core/request'
export class AspenUserOrgListService {
    /**
     * Get User Organizations
     * ## Description
     * Gets the currently logged-in user's organizations list for Aspen
     * @returns Auth0UserOrganizationsDTO Successful Response
     * @throws ApiError
     */
    public static getUserOrganizationsIdentityOrganizationsGet(): CancelablePromise<Auth0UserOrganizationsDTO> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/aspen/identity/organizations'
        })
    }
}
